// extracted by mini-css-extract-plugin
export var conversationListItem = "_x0-2";
export var fullBleedList = "_x0-3";
export var messageText = "_x0-1";
export var previewText = "_x0-0";